// Email provider mapping for "Open email app" feature
const EMAIL_PROVIDERS: Record<string, string> = {
  "gmail.com": "https://mail.google.com",
  "yahoo.com": "https://mail.yahoo.com",
  "outlook.com": "https://outlook.live.com",
  "hotmail.com": "https://outlook.live.com",
  "live.com": "https://outlook.live.com",
  "aol.com": "https://mail.aol.com",
  "icloud.com": "https://www.icloud.com/mail",
  "proton.me": "https://mail.proton.me",
  "protonmail.com": "https://mail.proton.me",
  "zoho.com": "https://mail.zoho.com",
}

/**
 * Get the appropriate webmail URL for a given email address
 * Falls back to the email domain if provider is not recognized
 */
export const getWebmailUrl = (email: string): string => {
  const domain = email.split("@")[1]?.toLowerCase()
  return EMAIL_PROVIDERS[domain] || `https://${domain}`
}

/**
 * Validate email format using regex
 */
export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email)
}
